import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { Product } from '@vestiaire/api-sdk-angular';
import { CarouselProductClick } from '@app/shared/components/carroussel-products/carroussel-products.component';

@Component({
  selector: 'vc-product-section-carousel',
  templateUrl: './product-section-carousel.component.html',
  styleUrls: ['./product-section-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSectionCarouselComponent {
  @Input()
  title: string;
  @Input()
  productList: Product[];
  @Input()
  seoContext: string[] = [];

  @Output() carouselProductClick = new EventEmitter<CarouselProductClick>();

  onCarouselProductClick(event: CarouselProductClick) {
    this.carouselProductClick.emit(event);
  }
}
